import { ref, remove } from "firebase/database";
import { realTimeDB } from "../firebase";

const Historytab = ({id,title,historyTextSelected}) => {

    const handleRemoveItemFromHistory=(textselected)=>{
        historyTextSelected(textselected)
        remove(ref(realTimeDB,`programtypehistory/${id}`));
    }

    return ( 
        <li className="historycontent" onClick={()=>handleRemoveItemFromHistory(title)}
            style={{color:"black",fontFamily:"sans-serif",padding:"5px",cursor:"pointer",width:"100%",display:"flex",transition:"transform 0.3s ease-out",marginBottom:"0.5em"}}>
        <h4>{title}</h4>
        </li>
     );
}
export default Historytab;